<template>
  <div id="wrap">
    <Navbar :title="$t('我的账户')" />
    <div class="userInfo">
      <span class="">{{ $t('用户名') }}:</span>
      {{ userInfo.userphone }}
    </div>
    <LoginForm :formList="formList" confirmText="newAdd.Submit" @submit="onSubmit">
      <template #read>
        <div class="read_title">{{ $t('我们关心你的隐私') }}</div>
        <div class="text">{{ $t("所有用户数据均经过加密") }}</div>
      </template>
      <template #cancel>
        <div></div>
      </template>
    </LoginForm>
  </div>
</template>

<script>
import Navbar from "@/components/JNav";
import LoginForm from "@/view/login/components/form.vue";
import { maskMiddle } from "@/utils/common"
import { Toast } from "vant";
import { USERS_EDIT } from "@/api"

export default {
  name: "portrait",
  components: {
    [Toast.name]: Toast,
    Navbar,
    LoginForm,
  },
  data() {
    return {
      userInfo: {},
      formList: [
        {
          key: "username",
          img: require('@/assets/new/mine/username.png'),
          label: "请输入您的昵称",
          defaultValue: ''
        },
        {
          key: "email",
          img: require('@/assets/new/mine/email.png'),
          label: "请输入您的电子邮件",
          defaultValue: ''
        },
      ],
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    async onSubmit(values) {
      const { username, email } = values;
      if (!username) return Toast(this.$t('请输入您的昵称'));
      if (!email) return Toast(this.$t('请输入您的电子邮件'));
      Toast.loading({ duration: 0 });
      try {
        const res = await USERS_EDIT({ username, email });
        Toast.clear();
        Toast(res.msg)
        setTimeout(()=>{
          this.getUserInfo();
        },1000)
      } catch (error) {
        Toast(error.msg)
      }
    },
    getUserInfo() {
      Toast.loading({
        forbidClick: true,
        duration: 0,
      });
      this.$api.getUserInfo(
        (res) => {
          Toast.clear();
          this.userInfo = res;
          console.log();
          this.$nextTick(()=>{
            this.formList[0].defaultValue = res.username;
            this.formList[1].defaultValue = res.email;
          })
        },
        (err) => {
          Toast.clear();
          this.$toast(err);
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
#wrap {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow: hidden;
  background: #F5F5F9;
  .userInfo{
    font-size: calc(17rem / 16);
    height: calc(52rem / 16);
    line-height: calc(52rem / 16);
    display: flex;
    align-items: center;
    padding: calc(7.5rem / 16) calc(16rem / 16) 0;
    color: #000;
    span{
      margin-right: calc(15rem / 16);
    }
  }

  .read_title {
    font-size: calc(16rem / 16);
    color: #49a3f6;
    margin-top: calc(20rem / 16);
  }

  .text {
    color: #5e5e5e;
    font-size: calc(12rem / 16);
    margin-top: calc(13rem / 16);
  }

  /deep/ .form_list {
    margin-top: 0;
    .van-cell {
      background-color: #efefef !important;
      padding: 0 20px;
      border-radius: calc(10rem / 16);

      .van-field__body {
        height: 52px;
        line-height: 52px;
        background-color: transparent;
        padding: 0 0 0 10px;
      }

      input {
        color: #333;
      }
    }

    .iconfont {
      color: #a5a5a5;
    }

    .confirm {
      background: linear-gradient(-90deg, #ff3a3e, #ff1e30) !important;
      box-shadow: 0 5px 10px 0 rgba(255, 0, 16, .4);
      color: #fffefe !important;
      font-size: calc(14rem / 16);
      border-radius: calc(7.5rem / 16) !important;
      height: calc(52rem / 16);
      line-height: calc(52rem / 16);
      text-align: center;
      margin-top: calc(30rem / 16);
    }
  }

}
</style>